import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Pagination from "../../sharedComponents/Pagination";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import SuccessUpdateModal from "./SuccessUpdateModal";
import { PencilSquareIcon, PlusIcon } from "@heroicons/react/24/outline";
import {
  ChatBubbleLeftEllipsisIcon,
  EyeIcon,
  EyeSlashIcon,
  TrashIcon,
} from "@heroicons/react/24/solid";
import LoadingSpinner from "../../animation/LoadingSpinner";
import AddTestimonialForm from "./AddTestimonialForm";
import UpdateTestimonialForm from "./UpdateTestimonialForm";
import {
  CommentIdToFeedback,
  deleteComment,
  fetchAllCommentsAdmin,
  toggleCommentStatus,
} from "../../../redux/reducer/commentReducer";

const ShowTestimonials = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { allComments, loading, error, totalPages } = useSelector(
    (state) => state.comments
  );
  // const { allComments, loading, error } = useSelector(
  //   (state) => state.comments
  // );
  const [showAddForm, setShowAddForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [page, setPage] = useState(1);
  const limit = useState(10);
  const [searchBox, setSearchBox] = useState("");
  const [openInfoIdEN, setOpenInfoIdEN] = useState(null);
  const [openInfoIdAR, setOpenInfoIdAR] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [selectedTestimonialId, setSelectedTestimonialId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedActive, setSelectedActive] = useState(null);
  const itemsPerPage = 5;
  // console.log(allCoupons);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        await dispatch(
          fetchAllCommentsAdmin({ page, limit, search: searchBox })
        ).unwrap();
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [dispatch, page, searchBox]);
  // }, [dispatch, page, limit, searchBox]);

  // ✅ Filter and paginate
  // const filteredCoupons = allCoupons.filter((coupon) =>
  //   coupon.code.toLowerCase().includes(searchBox.toLowerCase())
  // );

  // const totalPages = Math.ceil(filteredCoupons.length / itemsPerPage);


  const fetchData = async () => {
    try {
      setIsLoading(true);
      await dispatch(
        fetchAllCommentsAdmin({ page, limit, search: searchBox })
      ).unwrap();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };
  const startIndex = (page - 1) * itemsPerPage;

  const handleTrashClick = (testimonialId) => {
    setSelectedTestimonialId(testimonialId);
    setDeleteModalOpen(true);
  };
  const handleUpdateClick = (testimonial) => {
    setSelectedTestimonialId(testimonial);
    setShowUpdateForm(true);
  };
  const toggleInfo = (_id) => {
    setOpenInfoIdEN((prevId) => (prevId === _id ? null : _id));
  };
  const toggleInfoAR = (_id) => {
    setOpenInfoIdAR((prevId) => (prevId === _id ? null : _id));
  };
  const handleDeleteConfirm = async () => {
    try {
      setIsLoading(true);
      await dispatch(deleteComment(selectedTestimonialId)).unwrap();
      await dispatch(fetchAllCommentsAdmin({ page, limit, search: searchBox }));
      setIsLoading(false);
    } catch (error) {
      console.error("Toggle status error:", error);
      setIsLoading(false);
    }
    setDeleteModalOpen(false);
    setSelectedTestimonialId(null);
  };
  const handleToggleStatusView = async (testimonial) => {
    // console.log(
    //   testimonial?.comment_AR !==""
    // );
    // console.log(!testimonial?.isView);
    if (
      (testimonial?.comment_AR === "" || testimonial?.comment_EN === "") &&
      !testimonial?.isView
    ) {
      alert(
        "Please provide your comment in both Arabic and English to ensure it can be understood by all users."
      );
      return;
    }
    try {
      setIsLoading(true);
      await dispatch(toggleCommentStatus(testimonial?._id)).unwrap();
      await dispatch(fetchAllCommentsAdmin({ page, limit, search: searchBox }));
      setIsLoading(false);
    } catch (error) {
      console.error("Toggle status error:", error);
    }
  };
  const handleToggleStatusActive = async (testimonialId) => {
    try {
      setIsLoading(true);
      await dispatch(CommentIdToFeedback(testimonialId)).unwrap();
      await dispatch(fetchAllCommentsAdmin({ page, limit, search: searchBox }));
      setIsLoading(false);
    } catch (error) {
      console.error("Toggle status error:", error);
    }
  };
  // console.log(allComments);

  return (
    <div className="w-full overflow-x-auto ">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold text-black">{t("Testimonials")}</h1>
        <div className="flex items-center gap-3">
          {/* Active Filter */}
          {/* <select
            className="px-2 py-1 text-black bg-white border disabled:bg-gray-700 disabled:text-gray-200"
            value={
              selectedActive === "" ? "" : selectedActive ? "true" : "false"
            }
            onChange={(e) => {
              const value = e.target.value;
              if (value === "") {
                setSelectedActive("");
              } else {
                setSelectedActive(value === "true");
              }
            }}
          >
            <option value="null" className="text-black">
              Filter by Active
            </option>
            <option value="true" className="text-black">
              Active
            </option>
            <option value="false" className="text-black">
              Deactive
            </option>
          </select> */}

          <input
            type="text"
            placeholder="Search by Name"
            value={searchBox}
            onChange={(e) => {
              setSearchBox(e.target.value);
              setPage(1);
            }}
            className="px-2 py-2 text-black bg-white border"
          />
          <button
            className="flex items-center gap-2 px-3 py-2 bg-custom-yellow hover:bg-black group"
            onClick={() => setShowAddForm(true)}
          >
            <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
            <span className="text-black group-hover:text-white">
              Add Testimonial
            </span>
          </button>
        </div>
      </div>

      {loading ? (
        <div>
          <LoadingSpinner />
        </div>
      ) : error ? (
        <div className="text-center text-red-500">{error}</div>
      ) : allComments.length > 0 ? (
        <table className="min-w-full mb-8 text-sm border border-gray-200 divide-y divide-gray-200">
          <thead className="font-bold cursor-pointer bg-custom-yellow">
            <tr>
              <th className="px-4 py-2 text-center">{t("ID")}</th>
              <th className="px-4 py-2 text-center">{t("Name")}</th>
              <th className="px-4 py-2 text-center">{t("Comment_EN")}</th>
              <th className="px-4 py-2 text-center">{t("Comment_AR")}</th>
              <th className="px-4 py-2 text-center">{t("Evaluation")}</th>
              <th className="px-4 py-2 text-center">{t("Nationality")}</th>
              <th className="px-4 py-2 text-center">{t("Image")}</th>
              <th className="px-4 py-2 text-center">{t("Created At")}</th>
              <th className="px-4 py-2 text-center">{t("Actions")}</th>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            {allComments.map((reviews, index) => (
              <tr key={reviews?._id}>
                <td className="px-4 py-2 text-center">
                  {startIndex + index + 1}
                </td>
                <td className="px-4 py-2 text-center">{reviews?.name}</td>
                <td className="px-4 py-2 text-center">
                  <div className="relative inline-block info-dropdown">
                    <button
                      onClick={() => toggleInfo(reviews?._id)}
                      className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                    >
                      Show Info
                    </button>
                    {openInfoIdEN === reviews?._id && (
                      <div className="absolute left-1/2 -translate-x-1/2 z-50 w-[250px] px-2 py-1 mt-2 text-sm  bg-white border  shadow text-center">
                        {reviews?.comment_EN}
                      </div>
                    )}
                  </div>
                </td>
                <td className="px-4 py-2 text-center">
                  <div className="relative inline-block info-dropdown">
                    <button
                      onClick={() => toggleInfoAR(reviews?._id)}
                      className="flex px-2 py-2 text-xs text-black cursor-pointer bg-custom-yellow"
                    >
                      Show Info
                    </button>
                    {openInfoIdAR === reviews?._id && (
                      <div className="absolute left-1/2 -translate-x-1/2 z-50 w-[250px] px-2 py-1 mt-2 text-sm  bg-white border  shadow text-center">
                        {reviews?.comment_AR}
                      </div>
                    )}
                  </div>
                </td>
                <td className="px-4 py-2 text-center">{reviews?.rate}</td>

                <td className="">
                  <div className="flex items-center justify-center gap-2 px-4 py-2 text-center">
                    <img
                      src={reviews?.flagUrl}
                      alt={reviews?.countryName}
                      className="w-6"
                    ></img>
                    <span>{reviews?.countryName}</span>
                  </div>
                </td>
                <td className="justify-center px-4 py-2 text-center ">
                  <img
                    src={reviews?.image}
                    alt={reviews?.name}
                    className="w-16 mx-auto"
                  ></img>
                </td>
                <td className="px-4 py-2 text-center">
                  {new Date(reviews?.createdAt).toLocaleDateString()}
                </td>

                <td className="px-4 py-2 text-center">
                  <div className="flex items-center justify-center h-full gap-4">
                    {reviews?.isView ? (
                      <EyeIcon
                        className="w-5 h-5 text-blue-500 cursor-pointer"
                        onClick={() => handleToggleStatusView(reviews)}
                      />
                    ) : (
                      <EyeSlashIcon
                        className="w-5 h-5 text-gray-400 cursor-pointer"
                        onClick={() => handleToggleStatusView(reviews)}
                      />
                    )}
                    <PencilSquareIcon
                      className="w-5 h-5 text-gray-500 cursor-pointer"
                      onClick={() => handleUpdateClick(reviews)}
                    />
                    {reviews?.isActive ? (
                      <ChatBubbleLeftEllipsisIcon
                        className="w-5 h-5 text-green-500 cursor-pointer"
                        onClick={() => handleToggleStatusActive(reviews?._id)}
                      />
                    ) : (
                      <ChatBubbleLeftEllipsisIcon
                        className="w-5 h-5 text-gray-400 cursor-pointer"
                        onClick={() => handleToggleStatusActive(reviews?._id)}
                      />
                    )}
                    <TrashIcon
                      className="w-5 h-5 text-red-500 cursor-pointer"
                      onClick={() => handleTrashClick(reviews?._id)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="w-full mt-10 text-center text-gray-500">
          No Testimonials found
        </div>
      )}

      {/* ✅ Pagination */}
      <div className="flex flex-col items-center mb-4 text-center sm:flex-row sm:items-start sm:text-left">
        <div className="w-full sm:w-1/2"></div>
        <div className="flex justify-center w-full sm:w-1/2 sm:justify-end">
          <Pagination
            currentPage={page}
            totalPages={totalPages ? totalPages : 1}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </div>
      </div>

      {showAddForm && (
        <AddTestimonialForm onClose={() => setShowAddForm(false)} fetchData={fetchData} />
      )}
      {showUpdateForm && (
        <UpdateTestimonialForm
          onClose={() => setShowUpdateForm(false)}
          testimonialData={selectedTestimonialId}
        />
      )}

      <DeleteConfirmationModal
        isOpen={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteConfirm}
      />
      <SuccessUpdateModal
        isOpen={updateModalOpen}
        onClose={() => setUpdateModalOpen(false)}
      />
    </div>
  );
};

export default ShowTestimonials;
